import React from 'react';
import BlankButton from '@xo-union/component-blank-button';

interface Props {
  children: React.ReactNode;
}

export default ({ children, ...rest }: Props) => (
  <BlankButton type="button" {...rest}>
    {children}
  </BlankButton>
);
